import React from 'react';
import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../css_variables';
import loader from '../../../../images/loaders/loader-animation.svg';

const Loader = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	background-size: 80px 80px;
	background-image: url(${loader});
	background-repeat: no-repeat;
	background-position: center;
	justify-content: center;
	align-items: center;
`;

const LoaderText = styled.div`
	font-size: 11px;
	padding-top: 45px;
	color: ${CSS_CONSTANTS.v2_text_light_gray};
	font-style: italic;
`;

const InlineLoader = ({loaderText}) => {
	return (
		<Loader data-cy={'loader'}>
			<LoaderText>{loaderText}</LoaderText>
		</Loader>
	);
};

export default InlineLoader;
